'use es6';

import Quote from 'customer-data-objects/quote/QuoteInboundDbRecord';
import PropTypes from 'prop-types';
const QuoteType = PropTypes.instanceOf(Quote);
export default QuoteType;